import { useEffect} from "react";
import LOGO1 from "../../images/YellowPhoneWithWpuNumbersWhite.png";
import LOGO2 from "../../images/wpuLogo.svg";
import Searchbox from "./components/searches/SearchPhoneBox.jsx";
import CopyRight from "./components/auxiliary/PhoneCopyRight.jsx";
import { useData } from "./context/PhoneDirectoryContext.js";
import AnimatedSprite from "./components/animatedSprite/index.jsx";
import Sprite from "./components/animatedSprite/sprites.json";
import CopyRightFooter from "../../components/CopyRightFooter/CopyRightFooter.jsx";
import phoneDirectoryStyle from "./phoneDirectoryStyle.module.css";
import PhoneCard from "./components/cards/PhoneCard.jsx";

function PhoneDirectory() {
  const { filteredData } = useData();
  const { name, numberOfSlides, delay } = Sprite.s6;

  return (
    <>
      <div className="appContainer">
        <main className="appBody">
          <div className={phoneDirectoryStyle.bodyContents}>
            <div className={phoneDirectoryStyle.cardList} >
              <CopyRight />
              {filteredData && filteredData.length > 0 ? (
                filteredData.map((element, index) => {
                  return (
                    <PhoneCard element={element} index={index} key={index}></PhoneCard>
                  );
                })
              ) : (
                <AnimatedSprite
                  errorMsg={" ... لا يوجد اتصال مع المخدم"}
                  name={name}
                  slides={numberOfSlides}
                  delay={delay}
                ></AnimatedSprite>

                // <Error
                //   errorStyle={phoneDirectoryStyle.errorCard}
                //   errorMsg={"... لا يوجد اتصال مع المخدم"}
                // ></Error>
              )}
            </div>
          </div>
        </main>
        <header
          className="appHeader"
          onClick={() => {
            const el = document.querySelector("#firstCard");
            if (el) el.scrollIntoView(true);
          }}
        >
          <div className={phoneDirectoryStyle.headerContent}>
            <div className={phoneDirectoryStyle.search}>
            <img alt="PhoneNumber" src={LOGO1}  className={phoneDirectoryStyle.img1}/>
            <img alt="WPUlogo" src={LOGO2}  className={phoneDirectoryStyle.img2}/>
              <Searchbox />
            </div>
          </div>
        </header>
        <footer className="appFooter">
          <CopyRightFooter></CopyRightFooter>
        </footer>
      </div>
    </>
  );
}

export default PhoneDirectory;
